import Image from 'next/image';
import React from 'react';

const IntegrationsTechDataEngineering = () => {
    return (
        <div className="section-py !pt-0 !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            We utilize a comprehensive set of industry-leading platforms and tools to build scalable, secure, and efficient data engineering and analytics foundations. Our technology ecosystem spans the entire data lifecycle from ingestion and storage to transformation, quality assurance, and governance. This curated stack enables us to design modern, cloud-native data architectures that power enterprise analytics and AI initiatives with reliability, performance, and cost efficiency.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-orchestration-framework.svg"
                                width={36}
                                height={36}
                                alt="Cloud Data Warehouses"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Cloud Data Warehouses</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Enable enterprise-scale analytics with Snowflake, Amazon Redshift, Google BigQuery, Azure Synapse Analytics, and Oracle Autonomous Data Warehouse delivering optimized performance for complex BI workloads and AI-ready infrastructure.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="Data Lakes and Lakehouses" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Lakes and Lakehouses</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Unify structured and unstructured data using Databricks Lakehouse Platform, AWS S3 with Glue, Azure Data Lake Storage, Google Cloud Storage, Delta Lake, and Apache Iceberg for flexible, scalable analytics foundations.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-llm-integration.svg"
                                width={36}
                                height={36}
                                alt="ETL/ELT and Data Integration Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">ETL/ELT and Data Integration Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Streamline data movement with Apache Airflow, Fivetran, Airbyte, dbt, Talend, Informatica, AWS Glue, and Azure Data Factory enabling efficient extraction, transformation, and loading across diverse enterprise sources.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-vector-database.svg"
                                width={36}
                                height={36}
                                alt="Real-time Streaming Platforms"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Real-time Streaming Platforms</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Process continuous data flows using Apache Kafka, AWS Kinesis, Azure Event Hubs, Google Pub/Sub, Apache Flink, Spark Streaming, and Confluent facilitating instant insights and real-time analytics for AI-driven decisions.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-rpa-tools.svg"
                                width={36}
                                height={36}
                                alt="Data Quality and Observability Frameworks"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Quality and Observability Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Ensure pipeline reliability with Great Expectations, Monte Carlo Data, Datafold, Anomalo, deequ, Apache Griffin, and Soda providing automated validation, quality monitoring, and anomaly detection across data workflows.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-minitoring-&-observation.svg"
                                width={36}
                                height={36}
                                alt="Data Orchestration Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Orchestration Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Manage complex workflow dependencies using Apache Airflow, Prefect, Dagster, AWS Step Functions, Azure Data Factory, and Google Cloud Composer ensuring reliable scheduling and comprehensive monitoring at enterprise scale.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                    
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-low-code-platforms.svg" width={36} height={36} alt="Data Modeling and Transformation Platforms" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Modeling and Transformation Platforms</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Build scalable analytical models with dbt, Dataform, SQL frameworks, Matillion, and Apache Spark enabling documentation, version control, and collaborative transformation development supporting business intelligence needs.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-integration-tools.svg"
                                width={36}
                                height={36}
                                alt="Data Cataloging and Governance Solutions"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Cataloging and Governance Solutions</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Enable data discovery and compliance through Alation, Collibra, Apache Atlas, AWS Glue Data Catalog, Azure Purview, and Atlan providing metadata management, lineage tracking, and governance enforcement capabilities.
                        </p>
                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default IntegrationsTechDataEngineering;
